import { useEffect, useMemo, useRef, useState } from "react";

const Draggable = ({
  innerRef,
  rootClass = "",
  children,
  showMiniMap = true,
}) => {
  const ourRef = useRef(null);
  const mainRef = useRef(null);

  const secondRef = useRef(null);

  const [isMouseDown, setIsMouseDown] = useState(false);
  const mouseCoords = useRef({
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    scrollTop: 0,
  });
  const [isScrolling, setIsScrolling] = useState(false);
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [scrollPercentageHeighth, setScrollPercentageHeigth] = useState(0);

  const handleDragStart = (e) => {
    if (!ourRef.current) return;
    const slider = ourRef.current.children[0];
    const startX = e.pageX - slider.offsetLeft;
    const startY = e.pageY - slider.offsetTop;
    const scrollLeft = slider.scrollLeft;
    const scrollTop = slider.scrollTop;
    mouseCoords.current = { startX, startY, scrollLeft, scrollTop };
    setIsMouseDown(true);
    document.body.style.cursor = "grabbing";
  };

  const handleDragStart2 = (e) => {
    if (!secondRef.current || !ourRef.current) return;
    const slider = ourRef.current.children[0];
    const startX = e.pageX - slider.offsetLeft;
    const startY = e.pageY - slider.offsetTop;
    const scrollLeft = slider.scrollLeft;
    const scrollTop = slider.scrollTop;
    mouseCoords.current = { startX, startY, scrollLeft, scrollTop };
    setIsMouseDown(true);
    document.body.style.cursor = "grabbing";
  };

  const handleDragEnd = () => {
    setIsMouseDown(false);
    if (!ourRef.current) return;
    document.body.style.cursor = "default";
  };

  const handleDragEnd2 = () => {
    setIsMouseDown(false);
    if (!secondRef.current) return;
    document.body.style.cursor = "default";
  };

  const handleDrag = (e) => {
    if (!isMouseDown || !ourRef.current || !innerRef?.current) return;
    e.preventDefault();

    mainRef.current = e;
    const slider = ourRef.current.children[0];

    const x = e.pageX - slider.offsetLeft;
    const y = e.pageY - slider.offsetTop;
    const walkX = (x - mouseCoords.current.startX) * 1.5;
    const walkY = (y - mouseCoords.current.startY) * 1.5;
    slider.scrollLeft = mouseCoords.current.scrollLeft - walkX;
    slider.scrollTop = mouseCoords.current.scrollTop - walkY;

    const {
      scrollLeft,
      scrollWidth,
      clientWidth,
      scrollHeight,
      clientHeight,
      scrollTop,
    } = innerRef.current;

    const percentage = (scrollLeft / (scrollWidth - clientWidth)) * 100;
    const percentageHeight = (scrollTop / (scrollHeight - clientHeight)) * 100;

    setScrollPercentageHeigth(percentageHeight);
    setScrollPercentage(percentage);
    // console.log(walkX, walkY);
  };

  const handleDrag2 = (e) => {
    if (!isMouseDown || !secondRef.current || !innerRef?.current) return;
    e.preventDefault();

    const slider = ourRef.current.children[0];

    const x = e.pageX - slider.offsetLeft;
    const y = e.pageY - slider.offsetTop;

    const walkX = (x - mouseCoords.current.startX) * 8.5;
    const walkY = (y - mouseCoords.current.startY) * 8.5;
    slider.scrollLeft = -(mouseCoords.current.scrollLeft - walkX);
    slider.scrollTop = -(mouseCoords.current.scrollTop - walkY);

    const {
      scrollLeft,
      scrollWidth,
      clientWidth,
      scrollHeight,
      clientHeight,
      scrollTop,
    } = innerRef.current;

    const percentage = (scrollLeft / (scrollWidth - clientWidth)) * 100;
    const percentageHeight = (scrollTop / (scrollHeight - clientHeight)) * 100;

    setScrollPercentageHeigth(percentageHeight);
    setScrollPercentage(percentage);

    // console.log(walkX, walkY);
  };

  return (
    <div className="draggable-container  w-full ">
      <div
        ref={ourRef}
        onMouseDown={handleDragStart}
        onMouseUp={handleDragEnd}
        onMouseMove={handleDrag}
        className={rootClass + " flex overflow-x-auto   mx-auto w-auto"}
      >
        {children}
      </div>

    {showMiniMap &&   <div className=" hidden sm:flex justify-center  ">
        <div
          onMouseDown={handleDragStart2}
          onMouseUp={handleDragEnd2}
          onMouseMove={handleDrag2}
          ref={secondRef}
          className=" bg-gray-200 w-48 relative  h-28 p-1 mb-10 "
        >
          <div
            className=" absolute h-10   w-8 rounded-md bg-gray-400  "
            style={{
              left: `${scrollPercentage}%`,
              top: `${scrollPercentageHeighth}%`,
            }}
          ></div>
        </div>
      </div>}
    </div>
  );
};

export default Draggable;
